<template>
  <div>
    <wc-data-box
      :title='title'
      :titleIcon='titleIcon'
      :titleIconColor='titleIconColor'
      :showEdit='showEdit'
      @edit='openEdit'
    >
      <template v-slot:toolbarButtons >
        <span v-if='showPendingSaveText' class='mr-1 primary--text font-italic font-weight-bold'>(Pending Save)</span>
        <span v-if='showPreCheckText' class='mx-1 purple--text font-weight-bold'>Pre-check</span>
      </template>
      <v-card-text>
        <span v-if='!project.field_instructions' class='font-italic grey--text text--lighten-2'>None...</span>
        <span>{{ project.field_instructions }}</span>
      </v-card-text>
    </wc-data-box>

    <wc-dialog
      :title='title'
      :icon='titleIcon'
      :iconColor='titleIconColor'
      :showDialog='showDialog'
      :saveText='saveText'
      @cancel='showDialog = false'
      @save='saveChanges'
    >
      <v-textarea outlined auto-grow v-model='projectCopy.field_instructions'></v-textarea>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'field-instructions',
  props: {
    project: {
      required: true
    },
    showEdit: {
      required: false,
      type: Boolean,
      default: true
    },
    showPendingSaveText: {
      required: false,
      type: Boolean,
      default: false
    },
    showPreCheckText: {
      required: false,
      type: Boolean,
      default: false
    },
    saveText: {
      required: false,
      type: String,
      default: "Save"
    },
    titleIcon: {
      required: false,
      type: String,
      default: "mdi-text-subject"
    },
    titleIconColor: {
      required: false,
      type: String,
      default: "success"
    }
  },
  data: () => ({
    isLoading: false,
    title: 'Field Instructions',
    projectCopy: [],
    showDialog: false
  }),
  methods: {
    openEdit () {
      this.projectCopy = _.cloneDeep(this.project)
      this.showDialog = true
    },
    saveChanges () {
      this.$emit('update', this.projectCopy)
      this.showDialog = false
    }
  }
}
</script>
